import React from "react";
import { useSelector } from "react-redux";

import { RenewalContactDetailsAccordionType } from "@/schema/renewal-page/middle-panel.schema";
import { RootState } from "@/store/root-reducer";

import ContactDetails from "./contact-details-section/contact-details";
import OrganizerDetails from "./contact-details-section/organizer-details";

type ContactDetailsContentType = {
  contactDetailsAccordionData: RenewalContactDetailsAccordionType;
};

function ContactDetailsContent(props: Readonly<ContactDetailsContentType>) {
  const {
    telephoneEditButtonLabel,
    organizerDetailsTitle,
    organizerAddressEditButtonLabel,
  } = props.contactDetailsAccordionData;

  const { attributes } = useSelector((state: RootState) => state.quote);

  const { organiser } = attributes;

  const organizerAddress = () => {
    let address = "";
    if (organiser?.firstLineOfAddress) {
      address += `${organiser?.firstLineOfAddress}, `;
    }

    if (organiser?.secondLineOfAddress) {
      address += `${organiser?.secondLineOfAddress}, `;
    }

    if (organiser?.city) {
      address += `${organiser?.city}, `;
    }

    return address;
  };

  return (
    <div className="flex flex-col">
      <ContactDetails
        telephoneEditButtonLabel={telephoneEditButtonLabel}
        email={organiser?.email ?? ""}
        mobile={organiser?.telephone ?? ""}
      />
      <OrganizerDetails
        organizerDetailsTitle={organizerDetailsTitle}
        organizerAddressEditButtonLabel={organizerAddressEditButtonLabel}
        organiserName={`${organiser?.firstName ?? ""} ${
          organiser?.lastName ?? ""
        }`}
        organiserAddress={organizerAddress()}
        postalCode={organiser?.postCode ?? ""}
      />
    </div>
  );
}

export default ContactDetailsContent;
